export default __webpack_public_path__ + "static/media/userAddIcon.c6c29149.svg";